angular.module('zc.zenclerkS')
  .component('zcsOldDeemedInvoice', {
    templateUrl: '/templates/zenclerk_s/sites/invoices/show/zcs_old_deemed_invoice.html',
    bindings: {
      invoice: '<',
      currency: '='
    },
    controllerAs: 'vm',
    controller: zcsOldDeemedInvoiceController
  });

function zcsOldDeemedInvoiceController() {
  const vm = this;

  vm.$onInit = () => {
    // do nothing
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/invoices/show/zcs_old_deemed_invoice.directive.js